var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefendo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 9.7",
    style: {
      enableBackground: "new 0 0 99.2 9.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E94539;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000141415249789909132680000015948753244753373064_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,0.1c0.9,0,1.6,0.3,2.2,0.8c0.6,0.6,0.8,1.2,0.7,2L14,6.8c-0.1,0.8-0.6,1.5-1.4,2 c-0.8,0.6-1.6,0.8-2.5,0.8H0L1.7,0L11.8,0.1L11.8,0.1z M3.3,7.4H10c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.4-0.7l0.5-3 c0-0.3,0-0.5-0.2-0.7s-0.4-0.3-0.7-0.3H4.1L3.3,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,0.1L28,2.4h-9l-0.2,1.3h7.8L26.2,6h-7.8l-0.2,1.4h9l-0.4,2.3H14.9l1.7-9.6L28.4,0.1L28.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,0.1l-0.4,2.3h-8.7L32.1,4h7.5l-0.4,2.3h-7.5l-0.6,3.4h-2.8L30,0.1C30,0.1,41.5,0.1,41.5,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,0.1l-0.4,2.3h-9l-0.2,1.3H53L52.6,6h-7.8l-0.2,1.4h9l-0.4,2.3h-12l1.7-9.6L54.8,0.1L54.8,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,0.1l6.8,6.4l1.1-6.4h2.8l-1.7,9.6h-2.8l-6.8-6.4l-1.1,6.4h-2.8l1.7-9.6H58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,0.1c0.9,0,1.6,0.3,2.2,0.8c0.6,0.6,0.8,1.2,0.7,2l-0.7,3.9c-0.1,0.8-0.6,1.5-1.4,2 c-0.8,0.6-1.6,0.8-2.5,0.8H69.4L71.1,0L81.2,0.1L81.2,0.1z M72.7,7.4h6.7c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.4-0.7l0.5-3 c0-0.3,0-0.5-0.2-0.7s-0.4-0.3-0.7-0.3h-6.7L72.7,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,0.1c0.9,0,1.6,0.3,2.1,0.8c0.5,0.6,0.7,1.2,0.6,2l-0.7,3.9c-0.1,0.8-0.6,1.5-1.3,2 c-0.7,0.6-1.5,0.8-2.4,0.8h-7.3c-0.9,0-1.6-0.3-2.1-0.8c-0.5-0.6-0.7-1.2-0.6-2l0.7-3.9c0.2-0.8,0.6-1.5,1.3-2 c0.7-0.6,1.5-0.8,2.4-0.8H96.5z M88.7,2.7c-0.2,0.2-0.4,0.4-0.4,0.7l-0.5,3c0,0.3,0,0.5,0.2,0.7s0.4,0.3,0.7,0.3h5.8 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.4-0.7l0.5-3c0-0.3,0-0.5-0.2-0.7s-0.4-0.3-0.7-0.3h-5.8C89.2,2.5,89,2.5,88.7,2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefendo);
export default __webpack_public_path__ + "static/media/defendo.aa74c41577a81daa0421605b7ffc0c8e.svg";
export { ForwardRef as ReactComponent };